/* ═══════════════════════════════════════════════════════
   ONIALLY — Auto CTA Services Block
   Fichier : assets/blog-auto-cta.js
   
   Insère automatiquement un bloc CTA multi-services
   dans chaque article de blog, juste avant la FAQ
   ou en fin d'article si pas de FAQ.
   ═══════════════════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', function () {

  /* ── 1. Trouver le conteneur de l'article ── */
  var articleBody = document.querySelector('.article-template__content')
    || document.querySelector('.article__content')
    || document.querySelector('.blog-article__content')
    || document.querySelector('[class*="article"] .rte')
    || document.querySelector('.rte');

  if (!articleBody) return;

  /* ── 2. Construire le HTML du bloc CTA ── */
  var ctaHTML = ''
    + '<div class="auto-cta">'
    + '  <div class="auto-cta__header">'
    + '    <div class="auto-cta__badge">Onially</div>'
    + '    <h3 class="auto-cta__title">Déléguez, automatisez, performez.</h3>'
    + '    <p class="auto-cta__subtitle">Nos solutions clé en main pour les e-commerçants qui veulent scaler sans sacrifier la qualité.</p>'
    + '  </div>'
    + '  <div class="auto-cta__grid">'
    + '    <a href="https://www.onially.com/products/service-client-e-commerce" class="auto-cta__card">'
    + '      <div class="auto-cta__icon">💬</div>'
    + '      <div class="auto-cta__card-content">'
    + '        <div class="auto-cta__card-title">Service client e-commerce</div>'
    + '        <div class="auto-cta__card-desc">Déléguez la gestion complète du SAV de votre boutique en ligne.</div>'
    + '      </div>'
    + '      <div class="auto-cta__arrow">→</div>'
    + '    </a>'
    + '    <a href="https://www.onially.com/products/moderation-commentaires-automatique" class="auto-cta__card">'
    + '      <div class="auto-cta__icon">🤖</div>'
    + '      <div class="auto-cta__card-content">'
    + '        <div class="auto-cta__card-title">Modération Meta par IA</div>'
    + '        <div class="auto-cta__card-desc">Masquez les commentaires négatifs sur vos pubs Facebook & Instagram 24/7.</div>'
    + '      </div>'
    + '      <div class="auto-cta__arrow">→</div>'
    + '    </a>'
    + '  </div>'
    + '</div>';

  /* ── 3. Insérer avant la FAQ ou en fin d'article ── */
  var faqBlock = articleBody.querySelector('.article-faq-data')
    || articleBody.querySelector('.auto-faq');

  if (faqBlock) {
    faqBlock.insertAdjacentHTML('beforebegin', ctaHTML);
  } else {
    articleBody.insertAdjacentHTML('beforeend', ctaHTML);
  }

});